(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.countdownIntervals = [];
    }

    handleClick(event) {
      const button = event.currentTarget;
      const row = button.closest('.announcement-bar__row');

      if (button.dataset.closeAnnouncement === 'row' && row) {
        row.remove();
      } else {
        this.remove();
      }
    }

    startCountdown(timer) {
      const endTime = Date.parse(timer.dataset.countdownEnd);
      if (Number.isNaN(endTime)) {
        timer.setAttribute('aria-label', 'Countdown date is not configured');
        return;
      }

      const values = {
        days: timer.querySelector('[data-countdown-days]'),
        hours: timer.querySelector('[data-countdown-hours]'),
        minutes: timer.querySelector('[data-countdown-minutes]'),
        seconds: timer.querySelector('[data-countdown-seconds]')
      };

      const update = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        values.days.textContent = String(days).padStart(2, '0');
        values.hours.textContent = String(hours).padStart(2, '0');
        values.minutes.textContent = String(minutes).padStart(2, '0');
        values.seconds.textContent = String(seconds).padStart(2, '0');
        timer.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);

        if (remaining === 0) {
          if (timer.dataset.hideWhenExpired === 'true') {
            timer.closest('.announcement-bar__row')?.remove();
          } else if (timer.dataset.expiredMessage) {
            timer.innerHTML = `<span class="announcement-bar__expired-message"></span>`;
            timer.firstElementChild.textContent = timer.dataset.expiredMessage;
            timer.setAttribute('aria-label', timer.dataset.expiredMessage);
          }
          return false;
        }
        return true;
      };

      if (!update()) return;
      const interval = window.setInterval(() => {
        if (!update()) window.clearInterval(interval);
      }, 1000);
      this.countdownIntervals.push(interval);
    }

    connectedCallback() {
      this.querySelectorAll('.announcement-bar__close').forEach((button) => {
        button.addEventListener('click', this.handleClick.bind(this));
      });
      this.querySelectorAll('[data-countdown]').forEach((timer) => this.startCountdown(timer));
    }

    disconnectedCallback() {
      this.countdownIntervals.forEach((interval) => window.clearInterval(interval));
      this.countdownIntervals = [];
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-slideshow"] && !Shopify.designMode) return;
  try {
    
  /* Grow the bars and count the numbers up the first time the chart scrolls into view. */
  if (!customElements.get('bas-chart')) {
    customElements.define('bas-chart', class extends HTMLElement {
      connectedCallback() {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.classList.add('is-armed');
        this.nums = [...this.querySelectorAll('.bas-chart__num')];
        this.nums.forEach((el) => (el.textContent = '0'));
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.classList.add('is-visible');
          this.count();
        }, { threshold: 0.3 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      count() {
        const start = performance.now();
        const duration = 1400;
        const tick = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          this.nums.forEach((el) => {
            const target = parseFloat(el.dataset.value) || 0;
            const decimals = (el.dataset.value.split('.')[1] || '').length;
            el.textContent = (target * eased).toFixed(decimals);
          });
          if (t < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sachi-lucky-popup"] && !Shopify.designMode) return;
  try {
    
  const SL_REVISION = '2026-07-15';
  const SL_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  class SachiLuckyPopup extends HTMLElement {
    async connectedCallback() {
      this.cfg = JSON.parse(this.querySelector('[data-cfg]').textContent);
      this.key = 'sachi-lucky';

      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
      const form = this.querySelector('[data-form]');
      if (form) form.addEventListener('submit', (e) => this.submit(e));

      this.answers = {};
      this.querySelectorAll('[data-choice]').forEach((b) =>
        b.addEventListener('click', () => {
          if (b.dataset.property) this.answers[b.dataset.property] = b.dataset.value;
          this.toEmail();
        })
      );
      const skip = this.querySelector('[data-skip]');
      if (skip) skip.addEventListener('click', () => this.toEmail());

      if (this.cfg.design) return this.open();
      if (!this.cfg.enable || !this.cfg.prizes.length) return;
      if (!(await this.eligible())) return;
      this.arm();
    }

    // ---- targeting -------------------------------------------------------
    async eligible() {
      const c = this.cfg;
      if (new URLSearchParams(location.search).has('lucky_preview')) return true;

      if (c.lockAfterWin && localStorage.getItem(this.key + ':won')) return false;
      if (Date.now() < Number(localStorage.getItem(this.key + ':snooze') || 0)) return false;

      if (c.hideLoggedIn && c.customer) return false;
      if (c.hideCustomers && c.orders > 0) return false;
      if (c.hideSubscribers && this.knownToKlaviyo()) return false;

      if (c.pageMode !== 'all') {
        const list = this.list(c.pagePaths);
        const hit = list.some((p) => {
          try {
            return new RegExp(p, 'i').test(location.pathname);
          } catch (e) {
            return location.pathname.includes(p);
          }
        });
        if (c.pageMode === 'include' ? !hit : hit) return false;
      }

      const allowed = this.list(c.countries);
      if (allowed.length) {
        let country = (c.market || '').toUpperCase();
        if (c.useIpCountry) country = (await this.ipCountry()) || country;
        if (!allowed.includes(country)) return false;
      }
      return true;
    }

    list(raw) {
      return String(raw || '')
        .split(/[,\n]/)
        .map((v) => v.trim())
        .filter(Boolean);
    }

    knownToKlaviyo() {
      const m = document.cookie.match(/__kla_id=([^;]+)/);
      if (!m) return false;
      try {
        const d = JSON.parse(atob(decodeURIComponent(m[1])));
        return Boolean(d.$email || d.$exchange_id);
      } catch (e) {
        return false;
      }
    }

    async ipCountry() {
      try {
        const r = await fetch('/browsing_context_suggestions.json');
        const d = await r.json();
        return (d.detected_values && d.detected_values.country && d.detected_values.country.handle || '').toUpperCase();
      } catch (e) {
        return '';
      }
    }

    // ---- triggers --------------------------------------------------------
    arm() {
      const c = this.cfg;
      const fire = () => this.open();

      if (c.delay >= 0) this.timer = setTimeout(fire, c.delay * 1000);

      if (c.scrollPct > 0) {
        this.onScroll = () => {
          const max = document.body.scrollHeight - innerHeight;
          if (max > 0 && (scrollY / max) * 100 >= c.scrollPct) fire();
        };
        addEventListener('scroll', this.onScroll, { passive: true });
      }

      if (c.exitIntent) {
        this.onLeave = (e) => {
          if (e.clientY <= 0) fire();
        };
        document.addEventListener('mouseout', this.onLeave);
      }
    }

    disarm() {
      clearTimeout(this.timer);
      if (this.onScroll) removeEventListener('scroll', this.onScroll);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
    }

    // ---- open / close ----------------------------------------------------
    open() {
      if (this.opened) return;
      this.opened = true;
      this.disarm();
      this.prize = this.pickPrize();
      this.hidden = false;
      document.body.style.overflow = 'hidden';
      this.querySelector('.sachi-lucky__dialog').focus();
      if (this.cfg.game === 'cards') this.buildCards();
      else this.buildScratch();
    }

    close() {
      this.hidden = true;
      this.opened = false;
      document.body.style.overflow = '';
      this.disarm();
      if (this.cfg.design) return;
      if (this.cfg.snoozeDays > 0) {
        localStorage.setItem(this.key + ':snooze', Date.now() + this.cfg.snoozeDays * 864e5);
      }
    }

    step(name) {
      this.querySelectorAll('[data-step]').forEach((el) => {
        el.hidden = el.dataset.step !== name;
      });
    }

    // ponytail: prize drawn client-side. Anyone reading the JS sees the odds and codes,
    // which is fine because the codes are shared and Shopify caps their usage.
    // Move to a server endpoint only if you switch to per-visitor unique codes.
    pickPrize() {
      const prizes = this.cfg.prizes;
      const total = prizes.reduce((sum, p) => sum + Math.max(0, p.weight), 0);
      let r = Math.random() * total;
      return prizes.find((p) => (r -= Math.max(0, p.weight)) < 0) || prizes[0];
    }

    // ---- game: pick a card ----------------------------------------------
    buildCards() {
      const grid = this.querySelector('[data-cards]');
      grid.innerHTML = '';
      this.picked = 0;

      for (let i = 0; i < 9; i++) {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'sachi-lucky__card';
        card.setAttribute('aria-pressed', 'false');
        card.setAttribute('aria-label', 'Pick this card');
        card.innerHTML =
          '<span class="sachi-lucky__card-inner">' +
          '<span class="sachi-lucky__face">?</span>' +
          '<span class="sachi-lucky__face sachi-lucky__face--front"></span>' +
          '</span>';
        card.addEventListener('click', () => this.flip(card));
        grid.appendChild(card);
      }
    }

    flip(card) {
      if (card.getAttribute('aria-pressed') === 'true') return;
      card.querySelector('.sachi-lucky__face--front').textContent = this.prize.label;
      card.setAttribute('aria-pressed', 'true');
      card.disabled = true;
      this.picked++;
      if (this.picked >= this.cfg.picks) {
        this.querySelectorAll('.sachi-lucky__card').forEach((c) => (c.disabled = true));
        setTimeout(() => this.won(), this.cfg.revealDelay * 1000);
      }
    }

    // ---- game: scratch off ----------------------------------------------
    buildScratch() {
      const wrap = this.querySelector('[data-scratch]');
      const canvas = this.querySelector('[data-scratch-canvas]');
      this.querySelector('[data-scratch-prize]').textContent = this.prize.label;

      const rect = wrap.getBoundingClientRect();
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);

      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      const foil = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
      foil.addColorStop(0, '#d9c88f');
      foil.addColorStop(0.5, '#efe3b8');
      foil.addColorStop(1, '#c8b57a');
      ctx.fillStyle = foil;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = (canvas.width * this.cfg.brush) / 100;
      ctx.lineCap = ctx.lineJoin = 'round';

      let drawing = false;
      let last = null;
      let moves = 0;
      let finished = false;

      const check = () => {
        if (finished || this.erasedPct(ctx, canvas) < this.cfg.threshold) return;
        finished = true;
        wrap.classList.add('is-done');
        setTimeout(() => this.won(), this.cfg.revealDelay * 1000);
      };

      const pos = (e) => {
        const r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * canvas.width, y: ((e.clientY - r.top) / r.height) * canvas.height };
      };
      const start = (e) => {
        drawing = true;
        last = pos(e);
        canvas.setPointerCapture(e.pointerId);
        this.querySelector('[data-scratch-hint]').style.opacity = '0';
      };
      const move = (e) => {
        if (!drawing) return;
        const p = pos(e);
        ctx.beginPath();
        ctx.moveTo(last.x, last.y);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
        last = p;
        if (++moves % 10 === 0) check();
      };
      const end = () => {
        if (!drawing) return;
        drawing = false;
        check();
      };

      canvas.addEventListener('pointerdown', start);
      canvas.addEventListener('pointermove', move);
      canvas.addEventListener('pointerup', end);
      canvas.addEventListener('pointercancel', end);
    }

    erasedPct(ctx, canvas) {
      const d = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let clear = 0;
      let total = 0;
      for (let i = 3; i < d.length; i += 4 * 16) {
        total++;
        if (d[i] < 32) clear++;
      }
      return total ? (clear / total) * 100 : 0;
    }

    // ---- win -> capture --------------------------------------------------
    won() {
      ['[data-collect-heading]', '[data-won-heading]', '[data-won-text]'].forEach((sel) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = el.textContent.replace('{prize}', this.prize.label);
      });
      if (this.querySelector('[data-step="collect"]')) this.step('collect');
      else this.toEmail();
    }

    toEmail() {
      this.step('email');
      this.querySelector('.sachi-lucky__input').focus();
    }

    async submit(e) {
      e.preventDefault();
      const input = this.querySelector('.sachi-lucky__input');
      const err = this.querySelector('[data-error]');
      const btn = this.querySelector('[data-submit]');
      const email = input.value.trim();

      err.hidden = true;
      if (!SL_EMAIL.test(email)) {
        err.textContent = 'Please enter a valid email address.';
        err.hidden = false;
        input.focus();
        return;
      }

      btn.setAttribute('aria-busy', 'true');
      try {
        await this.toKlaviyo(email);
      } catch (error) {
        console.error('[sachi-lucky]', error);
        btn.removeAttribute('aria-busy');
        err.textContent = this.cfg.errorText || 'Something went wrong. Please try again.';
        err.hidden = false;
        return;
      }
      btn.removeAttribute('aria-busy');

      localStorage.setItem(this.key + ':won', this.prize.code || '1');
      this.querySelector('[data-code]').textContent = this.prize.code;
      const note = this.querySelector('[data-prize-note]');
      note.textContent = this.prize.description || '';
      note.hidden = !this.prize.description;
      // Come back to whatever page they were on, not the homepage.
      const back = location.pathname + location.search.replace(/[?&]lucky_preview=1/, '');
      const apply = this.querySelector('[data-apply]');
      const href = this.applyHref(back);
      apply.href = href || '#';
      apply.hidden = !href;
      if (this.prize.buttonLabel) apply.textContent = this.prize.buttonLabel;
      this.step('done');
    }

    // A prize link is used as the discount redirect when it is internal, so the code still
    // applies on the way through. An external link can't be a Shopify redirect, so it is
    // followed directly and the code stays on screen for them to copy.
    applyHref(back) {
      const url = String(this.prize.url || '').trim();
      const internal = url.startsWith('/');
      if (this.prize.code && (internal || !url)) {
        return '/discount/' + encodeURIComponent(this.prize.code) + '?redirect=' + encodeURIComponent(url || back);
      }
      return url;
    }

    publicKey() {
      if (this.cfg.publicKey) return this.cfg.publicKey;
      const tag = document.querySelector('script[src*="klaviyo.com/onsite/js/"]');
      const m = tag && tag.src.match(/company_id=([^&]+)/);
      return m ? m[1] : '';
    }

    async toKlaviyo(email) {
      const key = this.publicKey();
      if (!key) throw new Error('No Klaviyo public key found');

      const post = (path, body) =>
        fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'content-type': 'application/json', revision: SL_REVISION },
          body: JSON.stringify(body),
        }).then((r) => {
          if (!r.ok) throw new Error(path + ' failed: ' + r.status);
          return r;
        });

      const profile = {
        data: {
          type: 'profile',
          attributes: {
            email: email,
            properties: Object.assign(
              { last_game_prize: this.prize.label, last_game_code: this.prize.code },
              this.answers
            ),
          },
        },
      };

      if (this.cfg.listId) {
        await post('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Sachi lucky popup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                    properties: profile.data.attributes.properties,
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: this.cfg.listId } } },
          },
        });
      }

      // Event is best-effort: the subscribe above is what matters.
      post('events', {
        data: {
          type: 'event',
          attributes: {
            properties: Object.assign(
              { prize: this.prize.label, code: this.prize.code, game: this.cfg.game },
              this.answers
            ),
            metric: { data: { type: 'metric', attributes: { name: this.cfg.eventName } } },
            profile: profile,
          },
        },
      }).catch((e) => console.warn('[sachi-lucky] event', e));

      if (window.klaviyo) window.klaviyo.push(['identify', { $email: email }]);
    }
  }

  if (!customElements.get('sachi-lucky-popup')) {
    customElements.define('sachi-lucky-popup', SachiLuckyPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-clocks"] && !Shopify.designMode) return;
  try {
    
  /* Two clocks explainer: plays on a timeline when it comes into view. The drawing is the same as the
     scroll version; only the driver changed (time instead of scroll position). */
  if (!customElements.get('fv-two-clocks')) {
    customElements.define('fv-two-clocks', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        const root = this;
        const uid = root.dataset.uid;
        const svg = root.querySelector('[data-fv-svg]');
        const NS = 'http://www.w3.org/2000/svg';
        const STAGES = 6, ANIM = .7;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

        const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
        const ease = t => t * t * (3 - 2 * t);
        const lerp = (a, b, t) => a + (b - a) * t;
        let seed = 7; const rnd = () => { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
        const el = (tag, attrs, parent) => { const n = document.createElementNS(NS, tag); for (const k in attrs) n.setAttribute(k, attrs[k]); parent && parent.appendChild(n); return n; };
        const G = n => svg.querySelector(`[data-g="${n}"]`), E = n => svg.querySelector(`[data-el="${n}"]`);

        /* ================= illustration ================= */
        // smooth curve through points (Catmull-Rom as cubic Béziers), so nothing looks hand-wobbly
        const f1 = n => n.toFixed(1);
        const smooth = pts => { let d = `M${f1(pts[0][0])} ${f1(pts[0][1])}`;
          for (let i = 0; i < pts.length - 1; i++) { const p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
            d += ` C${f1(p1[0] + (p2[0] - p0[0]) / 6)} ${f1(p1[1] + (p2[1] - p0[1]) / 6)} ${f1(p2[0] - (p3[0] - p1[0]) / 6)} ${f1(p2[1] - (p3[1] - p1[1]) / 6)} ${f1(p2[0])} ${f1(p2[1])}`; }
          return d; };
        // one long, gently waving strand; slope lets bundles cross each other like a loose weave
        const strand = (y, amp, period, slope, jitter) => { const ph = rnd() * 6.283, pts = [];
          for (let x = 20; x <= 640; x += 24) pts.push([x, y + slope * (x - 330) + amp * Math.sin(x / period * 6.283 + ph) + (rnd() - .5) * jitter]);
          return smooth(pts); };

        // Dermis, matched to the reference illustration:
        //  - collagen: long, flat bands sweeping across in big S-curves and crossing like a loose weave
        //    (rose, pale white and soft grey), never wiggly
        //  - capillaries: one smooth tapering stem, a side branch or two near the top, a small fork at each tip
        //  - cells: round, with a darker centre
        //  - base: a white wavy line over cream fat lobes
        const sweep = (y, amp, period, slope) => { const ph = rnd() * 6.283, pts = [];
          for (let x = -10; x <= 670; x += 34) pts.push([x, y + slope * (x - 330) + amp * Math.sin(x / period * 6.283 + ph)]);
          return smooth(pts); };
        const elastin = [];

        const BAND = {
          rose:  { c: '#d49c8b', o: .82, w: [2.8, 4] },
          blush: { c: '#e5baac', o: .85, w: [3, 4.6] },
          white: { c: '#fcf3ee', o: .9,  w: [3.4, 5] },
          grey:  { c: '#a9a19d', o: .42, w: [1.8, 2.6] },
          faint: { c: '#dcafa0', o: .45, w: [2.2, 3] }
        };
        const band = (parent, kind, drawn, y) => { const B = BAND[kind], w = B.w[0] + rnd() * (B.w[1] - B.w[0]);
          const p = el('path', Object.assign({ d: sweep(y, 20 + rnd() * 24, 440 + rnd() * 280, (rnd() - .5) * .42),
            pathLength: 100, stroke: B.c, 'stroke-width': w.toFixed(2), opacity: B.o, 'stroke-linecap': 'butt' },
            drawn ? { 'stroke-dasharray': '100 100', 'stroke-dashoffset': 100 } : {}), parent);
          return { p, w }; };
        // order matters: grey and faint sit underneath, white and rose on top
        const ORDER = ['grey', 'faint', 'grey', 'blush', 'white', 'rose', 'faint', 'white', 'blush', 'rose', 'grey', 'white', 'rose', 'blush', 'white', 'rose'];
        // spread every colour evenly through the depth: heights are dealt out in a shuffled order
        const slots = ORDER.map((_, i) => 354 + (i / (ORDER.length - 1)) * 150);
        for (let i = slots.length - 1; i > 0; i--) { const j = Math.floor(rnd() * (i + 1)); [slots[i], slots[j]] = [slots[j], slots[i]]; }
        const fibres = ORDER.map((k, i) => Object.assign(band(G('fibres'), k, false, slots[i] + (rnd() - .5) * 10),
          // grey bands survive ageing (they're in the aged reference too); white and blush go first
          { th: k === 'grey' ? .95 : k === 'white' || k === 'blush' ? rnd() * .45 : .25 + rnd() * .5, n: 3 + Math.floor(rnd() * 3), off: rnd() * 100, rd: rnd() }));
        const newFibres = ['white', 'rose', 'blush', 'white', 'rose', 'blush'].map((k, i) => Object.assign(band(G('fibresNew'), k, true, 362 + i * 26 + (rnd() - .5) * 12), { dl: rnd() * .45 }));

        // capillaries
        const bez = (p0, p1, p2, p3, t) => { const u = 1 - t; return [
          u*u*u*p0[0] + 3*u*u*t*p1[0] + 3*u*t*t*p2[0] + t*t*t*p3[0],
          u*u*u*p0[1] + 3*u*u*t*p1[1] + 3*u*t*t*p2[1] + t*t*t*p3[1]]; };
        const vesselSegs = [];
        const curvedTwig = (x, y, ang, len, bend, w) => {   // short curved piece from (x,y), returns its end point and end angle
          const ex = x + Math.cos(ang) * len, ey = y + Math.sin(ang) * len;
          const nx = -Math.sin(ang) * bend, ny = Math.cos(ang) * bend;
          vesselSegs.push({ d: `M${f1(x)} ${f1(y)} Q${f1((x + ex) / 2 + nx)} ${f1((y + ey) / 2 + ny)} ${f1(ex)} ${f1(ey)}`, w });
          return [ex, ey, ang - Math.atan2(bend * 2, len)]; };
        const fork = (x, y, ang, len, w) => {   // the small Y at every tip
          curvedTwig(x, y, ang - .42 - rnd() * .15, len * (.8 + rnd() * .3), -len * .12, w);
          curvedTwig(x, y, ang + .38 + rnd() * .15, len * (.75 + rnd() * .3), len * .12, w); };
        const vessel = (x, y, ang, len, bend) => {
          const ex = x + Math.cos(ang) * len, ey = y + Math.sin(ang) * len, nx = -Math.sin(ang), ny = Math.cos(ang);
          const P0 = [x, y], P1 = [x + (ex - x) * .33 + nx * bend, y + (ey - y) * .33 + ny * bend],
                P2 = [x + (ex - x) * .7 + nx * bend * .8, y + (ey - y) * .7 + ny * bend * .8], P3 = [ex, ey];
          const pts = []; for (let i = 0; i <= 15; i++) pts.push(bez(P0, P1, P2, P3, i / 15));
          // tapering stem: three overlapping pieces, thinner towards the tip
          [[0, 6, 1.9], [5, 11, 1.5], [10, 15, 1.15]].forEach(([i0, i1, w]) => vesselSegs.push({ d: smooth(pts.slice(i0, i1 + 1)), w }));
          const tan = i => Math.atan2(pts[Math.min(15, i + 1)][1] - pts[Math.max(0, i - 1)][1], pts[Math.min(15, i + 1)][0] - pts[Math.max(0, i - 1)][0]);
          // one or two side branches near the top, alternating sides, each ending in its own little fork
          const nb = rnd() < .55 ? 2 : 1, side = rnd() < .5 ? 1 : -1;
          for (let b = 0; b < nb; b++) { const i = b ? 11 : 8, s2 = b ? -side : side;
            const [bx, by, ba] = curvedTwig(pts[i][0], pts[i][1], tan(i) + s2 * (.55 + rnd() * .2), len * (.24 + rnd() * .1), s2 * len * .05, 1.05);
            fork(bx, by, ba, len * .1, .85); }
          fork(ex, ey, tan(15), len * .16, .95);
        };
        // [x, y, angle (up = -1.57), length, bend]; mixed directions like the reference
        [[70, 512, -1.05, 92, 12], [150, 430, -1.35, 64, -8], [232, 515, -.85, 98, 14], [300, 405, -1.75, 58, 7],
         [372, 500, -1.2, 84, -10], [452, 452, -1.9, 66, 9], [500, 515, -.95, 96, 12], [584, 470, -1.45, 72, -9]]
          .forEach(([x, y, a, l, bnd]) => vessel(x + (rnd() - .5) * 8, y, a + (rnd() - .5) * .12, l * (.92 + rnd() * .16), bnd));
        vesselSegs.forEach(v => { el('path', { d: v.d, 'stroke-width': v.w.toFixed(2) }, G('vessels')); el('path', { d: v.d, 'stroke-width': (v.w + 1).toFixed(2) }, G('flush')); });
        const vessels = G('vessels'), flush = G('flush');

        // fibroblasts: round cells with a darker centre
        const fibro = [];
        [[110, 392], [232, 468], [350, 380], [458, 490], [540, 412]].forEach(([x, y], i) => {
          const g = el('g', { transform: `translate(${x} ${y})` }, G('fibroblasts'));
          const ring = el('g', { opacity: 0 }, g);   // "being signalled" pulse, shown during the dermal-signalling step
          el('circle', { class: 'fv-halo', r: 16, fill: 'none', stroke: '#c0725a', 'stroke-width': 1.2, style: `animation-delay:${(i * .37).toFixed(2)}s` }, ring);
          el('circle', { r: 9.5, fill: '#d6998a' }, g);
          el('circle', { r: 6.2, fill: '#c98573' }, g);
          el('circle', { r: 2.8, fill: '#a45e4b' }, g);
          fibro.push({ g, ring }); });

        // base: white wavy line, cream fat lobes beneath
        el('path', { d: 'M40 526 C150 518 250 533 340 525 S520 518 610 528 V560 H40 Z', fill: '#ecdccd' }, G('base'));
        for (let x = 28; x < 640; x += 46 + rnd() * 10)
          el('ellipse', { cx: f1(x + rnd() * 6), cy: f1(546 + rnd() * 4), rx: f1(20 + rnd() * 6), ry: f1(11 + rnd() * 3), fill: '#f2e5d8', stroke: '#fbf4ef', 'stroke-width': 2 }, G('base'));
        el('path', { d: 'M40 526 C150 518 250 533 340 525 S520 518 610 528', fill: 'none', stroke: '#fcf6f2', 'stroke-width': 3.5 }, G('base'));
        const cells = [], tones = ['#efdcd5', '#e8cfc6', '#dcb5a8', '#d3a594'];
        [[124, 6.5], [140, 7]].forEach(([y, ry], r) => { for (let x = 48 - (r ? 40 : 0); x < 620; x += 96)
          el('ellipse', { cx: x + 44, cy: y, rx: 42, ry, fill: tones[(Math.floor(x / 96) + r) % 3] }, G('cells')); });
        for (let r = 0; r < 4; r++) { const y = 154 + r * 40;
          for (let x = 48 - (r % 2 ? 50 : 0); x < 620; x += 100) { const g = el('g', {}, G('cells'));
            el('rect', { x: x + 4, y, width: 92, height: 34, rx: 7, fill: tones[(Math.floor(x / 100) + r) % 4] }, g);
            const ov = el('rect', { x: x + 4, y, width: 92, height: 34, rx: 7, fill: '#bfb5b0', opacity: 0 }, g);
            const nuc = el('circle', { cx: x + 30, cy: y + 17, r: 6.5, fill: '#fff' }, g);
            if (rnd() < .4) el('circle', { cx: x + 68, cy: y + 22, r: 4, fill: '#4a2f28' }, g);
            cells.push({ ov, nuc, fat: rnd() < .45 }); } }

        const SURF = 80, X0 = 48, X1 = 600, STEP = 3, fine = [], deep = [];
        for (let i = 0; i < 9; i++) fine.push({ x: 70 + i * 60 + rnd() * 24, w: 4 + rnd() * 3, d: 3 + rnd() * 3, sk: .8 + rnd() * .5 });
        [[132, 11, 15], [262, 13, 19], [408, 10, 14], [528, 12, 17]].forEach(([x, w, d]) => deep.push({ x, w, d, sk: .75 + rnd() * .5 }));
        function surfaceY(x, kf, kd) { let y = SURF;
          const add = (c, k) => { if (!k) return; let dx = x - c.x; dx *= dx < 0 ? c.sk : 1 / c.sk;
            y += k * c.d * (Math.exp(-((dx / c.w) ** 2)) - .2 * Math.exp(-((dx / (c.w * 2.8)) ** 2))); };
          fine.forEach(c => add(c, kf)); deep.forEach(c => add(c, kd)); return y; }
        const corneum = E('corneum'), creaseShade = E('creaseShade'), air = E('air'), edge = E('edge');
        let lastSurf = '';
        function drawSurface(kf, kd, lift) {
          const key = kf.toFixed(3) + kd.toFixed(3) + lift.toFixed(3); if (key === lastSurf) return; lastSurf = key;
          const top = [], bot = [];
          for (let x = X0 - 4; x <= X1 + 4; x += STEP) { const y = surfaceY(x, kf, kd) - lift; top.push([x, y]); bot.push([x, 110 - lift * .4 + (y - SURF + lift) * .35]); }
          const t = top.map(([x, y], i) => (i ? 'L' : 'M') + x + ' ' + y.toFixed(2)).join(' ');
          corneum.setAttribute('d', t + ' ' + bot.slice().reverse().map(([x, y]) => 'L' + x + ' ' + y.toFixed(2)).join(' ') + ' Z');
          edge.setAttribute('d', t);
          creaseShade.setAttribute('d', t + ' ' + top.map(([x, y]) => 'L' + x + ' ' + (y + Math.max(0, y - SURF + lift) * .7).toFixed(2)).reverse().join(' ') + ' Z');
          air.setAttribute('d', `M${X0 - 4} 40 L${X1 + 4} 40 ` + top.slice().reverse().map(([x, y]) => 'L' + x + ' ' + y.toFixed(2)).join(' ') + ' Z');
        }
        const drops = [];
        for (let i = 0; i < 16; i++) { const x = 70 + i * 33 + rnd() * 12, y = 100 + rnd() * 42;
          drops.push({ d: el('path', { d: `M${x} ${y - 7} C${x + 4} ${y - 1} ${x + 5} ${y + 3} ${x} ${y + 5} C${x - 5} ${y + 3} ${x - 4} ${y - 1} ${x} ${y - 7}Z`, fill: '#9db4bc', opacity: 0 }, G('drops')), k: rnd() }); }
        const cort = [];
        for (let i = 0; i < 16; i++) { const x = 70 + rnd() * 510;
          cort.push({ c: el('circle', { cx: x, cy: -10, r: 4.2, fill: '#9e4f3c', opacity: 0 }, G('cortisol')), ty: 100 + rnd() * 400, dl: rnd() * .35 }); }
        const calm = []; for (let i = 0; i < 3; i++) calm.push(el('ellipse', { cx: 320, cy: 70, rx: 0, ry: 0, opacity: 0 }, G('calm')));
        const ORB = [{ x: 200, end: 440, lab: '01' }, { x: 320, end: 254, lab: '02' }, { x: 440, end: 106, lab: '03' }];
        const orbs = ORB.map(o => { const g = el('g', { opacity: 0 }, G('orbs'));
          el('circle', { class: 'fv-halo', cx: o.x, cy: 30, r: 20, fill: '#d99a84', opacity: .5 }, g);
          el('circle', { class: 'fv-halo d2', cx: o.x, cy: 30, r: 20, fill: '#e6b3a1', opacity: .4 }, g);
          el('circle', { cx: o.x, cy: 30, r: 16, fill: `url(#fvOrb-${uid})` }, g);
          el('text', { x: o.x + 25, y: 22, 'font-size': 10.5 }, g).textContent = o.lab;
          const line = el('path', { d: `M${o.x} 54 V${o.end - 14}`, stroke: '#1d1d1b', 'stroke-width': 1.5, fill: 'none', pathLength: 1, 'stroke-dasharray': '1 1', 'stroke-dashoffset': 1 }, g);
          const head = el('g', { opacity: 0 }, g);
          el('path', { d: `M${o.x - 8} ${o.end - 16} L${o.x + 8} ${o.end - 16} L${o.x} ${o.end} Z`, fill: '#1d1d1b' }, head);
          el('path', { d: `M${o.x - 3.5} ${o.end - 13.5} L${o.x + 3.5} ${o.end - 13.5} L${o.x} ${o.end - 6} Z`, fill: '#fff' }, head);
          return { g, line, head }; });
        const ind = el('g', { opacity: 0 }, G('indigo'));
        el('circle', { class: 'fv-halo', cx: 320, cy: 30, r: 20, fill: '#8794b0', opacity: .5 }, ind);
        el('circle', { class: 'fv-halo d2', cx: 320, cy: 30, r: 20, fill: '#a9b3c8', opacity: .4 }, ind);
        el('circle', { cx: 320, cy: 30, r: 16, fill: `url(#fvOrbIndigo-${uid})` }, ind);
        el('text', { x: 345, y: 22, 'font-size': 10.5 }, ind).textContent = root.dataset.indigoLabel || '';
        const redness = E('redness'), cortLabel = E('cortisolLabel');

        /* ================= draw one moment of the story (p: 0..1) ================= */
        const callouts = [...root.querySelectorAll('[data-callout]')];
        function render(p) {
          const s = clamp(p, 0, .99999) * STAGES, idx = Math.floor(s), tt = clamp((s - idx) / ANIM);
          const seg = k => idx > k ? 1 : idx < k ? 0 : tt;
          const time = ease(seg(1)), stress = ease(seg(2)), lon = seg(3), nRaw = seg(4), goal = ease(seg(5));
          const n1 = ease(clamp(nRaw * 2)), n2 = ease(clamp(nRaw * 2 - 1));
          const a = i => ease(clamp((lon - i / 3) / .22)), e = i => ease(clamp((lon - i / 3 - .12) / .22));
          const e1 = e(0), e2 = e(1), e3 = e(2);

          const thin = time * (1 - e1), frag = stress * (1 - .55 * e1 - .45 * n1);
          // collagen: thins and goes sparse with time, breaks into short pieces under stress
          fibres.forEach(f => {
            const fade = ease(clamp((thin - f.th) / .3));
            f.p.style.opacity = (1 - .85 * fade).toFixed(3);
            f.p.setAttribute('stroke-width', (f.w * (1 - .35 * thin)).toFixed(2));
            if (frag > .01 && f.rd < .8) { const L = 100 / f.n, gap = L * .5 * frag;
              f.p.setAttribute('stroke-dasharray', `${(L - gap).toFixed(2)} ${gap.toFixed(2)}`); f.p.setAttribute('stroke-dashoffset', f.off.toFixed(1)); }
            else f.p.removeAttribute('stroke-dasharray'); });
          // new collagen is laid down by the peptides and fills in fully by the end
          const grow = Math.max(e1 * .55, goal);
          newFibres.forEach(f => { const g = ease(clamp((grow - f.dl) / .55));
            f.p.setAttribute('stroke-dashoffset', (100 - 100 * g).toFixed(1)); f.p.style.opacity = g > 0 ? '' : 0; });
          // elastin loosens with age; vessels thin with age and flush red under stress until Wild Indigo calms them
          const el1 = (1 - .55 * time * (1 - Math.max(e3 * .5, goal))).toFixed(3);
          elastin.forEach(p => p.style.opacity = el1);   // multiplies with each path's own opacity
          vessels.setAttribute('opacity', (.85 * (1 - .4 * time * (1 - goal))).toFixed(3));
          flush.setAttribute('opacity', (.7 * stress * (1 - n2)).toFixed(3));
          const act = clamp(1 - .7 * time + .7 * e1 + .2 * goal, .25, 1);
          fibro.forEach(f => { f.g.style.opacity = (.35 + .65 * act).toFixed(2);
            f.ring.setAttribute('opacity', (idx === 3 ? Math.min(1, e1 * 2) : 0).toFixed(2)); });
          const fatigue = Math.max(time * .45, stress * .85) * (1 - e2);
          cells.forEach(c => { c.ov.setAttribute('opacity', (c.fat ? fatigue * .7 : fatigue * .12).toFixed(2));
            c.nuc.setAttribute('r', (6.5 - (c.fat ? 2.5 * fatigue : 0)).toFixed(2)); });
          const kf = Math.max(time, stress) * (1 - Math.max(e3, e1 * .6)) * (1 - goal);
          const kd = stress * (1 - .45 * e1 - .45 * e3 - .1 * n2) * (1 - goal);
          drawSurface(kf, kd, goal * 2.5);
          const hyd = Math.max(e3, goal);
          drops.forEach(d => d.d.setAttribute('opacity', clamp((hyd - d.k * .5) / .5).toFixed(2)));
          redness.setAttribute('opacity', (stress * (1 - n2)).toFixed(2));
          cort.forEach(c => { const k = ease(clamp((stress - c.dl) / .65));
            c.c.setAttribute('cy', lerp(-10, c.ty, k).toFixed(1));
            c.c.setAttribute('r', (4.2 * (1 - n1 * .9)).toFixed(2));
            c.c.setAttribute('opacity', (k > 0 ? Math.min(1, k * 3) * (1 - n1) : 0).toFixed(2)); });
          cortLabel.setAttribute('opacity', (clamp(stress * 3) * (1 - clamp(n1 * 1.5))).toFixed(2));
          const out = 1 - clamp(nRaw * 3);
          orbs.forEach((o, i) => { const d = a(i);
            o.g.setAttribute('opacity', (clamp(lon * 6 - i * 1.5) * out).toFixed(2));
            o.line.setAttribute('stroke-dashoffset', (1 - d).toFixed(3));
            o.head.setAttribute('opacity', clamp((d - .9) * 10).toFixed(2)); });
          ind.setAttribute('opacity', (idx === 4 ? clamp(tt * 4) : idx > 4 ? 1 - clamp(goal * 2) : 0).toFixed(2));
          calm.forEach((c, i) => { const f = idx === 4 ? clamp(nRaw * 1.25 - i * .16) : 0;
            c.setAttribute('cy', (70 + 130 * f).toFixed(1)); c.setAttribute('rx', (30 + 300 * f).toFixed(1)); c.setAttribute('ry', (10 + 120 * f).toFixed(1));
            c.setAttribute('opacity', (f > 0 && f < 1 ? (1 - f) * .7 : 0).toFixed(2)); });
          callouts.forEach((c, i) => c.style.setProperty('--v', clamp(goal * 2.4 - .5 - i * .45).toFixed(3)));
        }

        /* ================= timeline =================
           9 beats across 6 chapters. Each beat animates for TR ms, then holds so the note can be read. */
        const BEATS = [
          { k: '0',  st: 0, f0: 0,   f1: 0,   w: .8 },
          { k: '1',  st: 1, f0: 0,   f1: 1,   w: 1 },
          { k: '2',  st: 2, f0: 0,   f1: 1,   w: 1.1 },
          { k: '3a', st: 3, f0: 0,   f1: .33, w: 1 },
          { k: '3b', st: 3, f0: .33, f1: .66, w: 1 },
          { k: '3c', st: 3, f0: .66, f1: 1,   w: 1 },
          { k: '4a', st: 4, f0: 0,   f1: .49, w: 1.05 },
          { k: '4b', st: 4, f0: .49, f1: 1,   w: 1.05 },
          { k: '5',  st: 5, f0: 0,   f1: 1,   w: 1.4 }
        ];
        const BASE = (parseFloat(root.dataset.beat) || 6.5) * 1000, TR = 2200;
        const LOOP = root.dataset.loop === 'true';
        const dur = b => BASE * BEATS[b].w;
        const pOf = (b, t) => { const B = BEATS[b]; return (B.st + ANIM * lerp(B.f0, B.f1, ease(clamp(t / TR)))) / STAGES; };

        /* ================= ui refs ================= */
        const $ = s => root.querySelector(s);
        const stacks = [...root.querySelectorAll('.fv-label>span, .fv-caption>span, .fv-explain>div')];
        const notes = [...root.querySelectorAll('[data-note]')];
        const steps = [...root.querySelectorAll('.fv-step')], stepFills = steps.map(s => s.querySelector('i'));
        const playBtn = $('[data-fv-play]'), results = $('[data-fv-results]'), svgbox = $('.fv-svgbox'), caption = $('.fv-caption');
        const L = { play: root.dataset.lPlay || 'Play', pause: root.dataset.lPause || 'Pause', replay: root.dataset.lReplay || 'Replay' };

        let beat = 0, t = 0, playing = false, userPaused = false, ended = false, inView = false;
        let cur = 0, raf = 0, lastNow = 0, hold = false, drawn = -1;

        function syncButton() {
          const st = ended ? 'ended' : playing ? 'playing' : 'paused';
          playBtn.dataset.state = st;
          playBtn.setAttribute('aria-label', st === 'ended' ? L.replay : st === 'playing' ? L.pause : L.play);
          caption.setAttribute('aria-live', st === 'playing' ? 'off' : 'polite');   // no chatter every few seconds while it plays
        }
        function syncUI() {
          const B = BEATS[beat];
          stacks.forEach(x => x.classList.toggle('is-on', x.dataset.k === B.k));
          notes.forEach(x => x.classList.toggle('is-on', x.dataset.note === B.k));
          results.classList.toggle('is-lit', B.k === '5');
          steps.forEach((b, i) => b.setAttribute('aria-current', i === B.st ? 'step' : 'false'));
          syncButton();
        }
        function drawProgress() {
          const st = BEATS[beat].st;
          const inChapter = BEATS.map((b, i) => i).filter(i => BEATS[i].st === st);
          const frac = (inChapter.indexOf(beat) + (reduce ? 1 : clamp(t / dur(beat)))) / inChapter.length;
          stepFills.forEach((f, i) => f.style.transform = `scaleX(${i < st ? 1 : i > st ? 0 : frac.toFixed(3)})`);
        }

        const kick = () => { if (!raf) { lastNow = performance.now(); raf = requestAnimationFrame(loop); } };
        function loop(now) {
          const dt = Math.min(100, now - lastNow); lastNow = now;
          if (playing && !(hold && t >= TR)) {   // hovering a note holds the step once its animation has finished
            t += dt;
            if (t >= dur(beat)) {
              if (beat < BEATS.length - 1) setBeat(beat + 1, true);
              else if (LOOP) setBeat(0, true);
              else { t = dur(beat); playing = false; ended = true; syncButton(); }
            }
          }
          const target = pOf(beat, t), d = target - cur;
          cur = (reduce || Math.abs(d) < .0004) ? target : cur + d * (1 - Math.pow(.86, dt / 16.7));
          if (cur !== drawn) { render(cur); drawn = cur; }
          drawProgress();
          raf = (playing || cur !== target) ? requestAnimationFrame(loop) : 0;
        }
        function setBeat(i, keepPlaying) {
          beat = i; t = reduce ? TR : 0;
          if (!keepPlaying) ended = false;
          syncUI(); kick();
        }
        function play() { if (ended) { ended = false; setBeat(0, true); } playing = true; syncButton(); kick(); }
        function pause() { playing = false; syncButton(); }

        /* the person is in charge: any jump resumes playing from there (unless reduced motion) */
        function jump(i) { ended = false; userPaused = false; setBeat(i); if (!reduce) play(); else { syncButton(); } }
        const firstBeatOf = ch => BEATS.findIndex(b => b.st === ch);

        playBtn.addEventListener('click', () => {
          if (ended) { userPaused = false; play(); return; }
          if (playing) { userPaused = true; pause(); } else { userPaused = false; play(); }
        });
        root.addEventListener('click', ev => {
          const step = ev.target.closest('.fv-step'); if (step) { jump(firstBeatOf(+step.dataset.step)); return; }
          // tabs are a plain accordion: they never touch the diagram, and the diagram never touches them
          const btn = ev.target.closest('.fv-tab-btn'); if (!btn) return;
          const tab = btn.closest('.fv-tab'), open = !tab.classList.contains('is-open');
          tab.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open);
          tab.querySelector('.fv-tab-panel').inert = !open;   // closed content is skipped by screen readers and keyboard
        });

        root.querySelectorAll('.fv-note-card, .fv-caption, .fv-explain').forEach(n => {
          n.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hold = true; });
          n.addEventListener('pointerleave', () => { hold = false; });
        });

        /* nothing plays on page load: it starts only once the diagram itself is at least 60% on screen
           (after a short beat so the visitor's eye lands first), and pauses when it scrolls away or the
           browser tab is hidden. It picks up where it left off when it comes back. */
        let startTimer = 0;
        this.io = new IntersectionObserver(entries => {
          const r = entries[0].intersectionRatio;
          if (r >= .6) {
            inView = true;
            if (!userPaused && !ended && !playing && !reduce && !startTimer)
              startTimer = setTimeout(() => { startTimer = 0; if (inView && !userPaused && !ended && !document.hidden) play(); }, 600);
          } else if (r < .3) {
            inView = false; clearTimeout(startTimer); startTimer = 0;
            if (playing) pause();
          }
        }, { threshold: [0, .3, .6, .8] });
        this.io.observe(svgbox);
        const onVis = () => { if (document.hidden) { if (playing) pause(); } else if (inView && !userPaused && !ended && !reduce) play(); };
        document.addEventListener('visibilitychange', onVis);

        /* layout: tiny-chart mode only */
        function layout() { root.classList.toggle('fv-tiny', svgbox.offsetWidth < 260); }
        let rt; const onResize = () => { clearTimeout(rt); rt = setTimeout(layout, 120); };
        addEventListener('resize', onResize);
        this.cleanup = () => { clearTimeout(startTimer); this.io.disconnect(); removeEventListener('resize', onResize); document.removeEventListener('visibilitychange', onVis); cancelAnimationFrame(raf); };

        layout(); syncUI(); render(0); drawn = 0; drawProgress();
        if (document.fonts) document.fonts.ready.then(layout);
        this.fvGoTo = i => { userPaused = true; playing = false; setBeat(i); t = TR; syncButton(); kick(); };
        this.fvState = () => ({ beat, t, playing, hold });   // previews: show a step fully drawn
      }

      disconnectedCallback() {
        if (this.cleanup) this.cleanup();
        this.started = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
